<div #modalRoot class="modal fade confirmation-modal" [id]="modalId()" msEscClose (escPressed)="onCancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">{{ title() }}</h5>
            </div>

            <div class="modal-body text-center">
                @switch (modalType()) {
                    @case (ModalTypes.Success) {
                        <fa-duotone-icon icon="circle-check" class="confirmation-icon text-success" />
                    }

                    @case (ModalTypes.Failure) {
                        <fa-duotone-icon icon="circle-xmark" class="confirmation-icon text-danger" />
                    }

                    @case (ModalTypes.Information) {
                        <fa-duotone-icon icon="circle-info" class="confirmation-icon text-primary" />
                    }

                    @case (ModalTypes.Question) {
                        <fa-duotone-icon icon="circle-question" class="confirmation-icon text-info" />
                    }

                    @case (ModalTypes.Exclamation) {
                        <fa-duotone-icon icon="circle-exclamation" class="confirmation-icon text-warning" />
                    }
                }
                <div class="pt-4 px-4" [innerHTML]="message()"></div>

                <div class="px-4 py-0">
                    <form [formGroup]="confirmModalForm" class="contact-form">
                            @if(enableNotes() === true) {
                                <ms-input-label [isRequired]="isNoteRequired()" [labelText]="'Notes'" class="mt-3" />
                                <textarea type="text" rows="3" id="note" [required]="isNoteRequired()" maxlength="255"
                                    formControlName="note" class="form-control"
                                    [class.is-invalid]="confirmModalForm.get('note')?.invalid && confirmModalForm.get('note')?.touched"
                                    [class.is-valid]="confirmModalForm.get('note')?.valid && confirmModalForm.get('note')?.touched && confirmModalForm.get('note')?.value !== ''">
                                </textarea>
                                @if(confirmModalForm.get('note')?.invalid && confirmModalForm.get('note')?.touched) {
                                <div class="error-messages">
                                    @if(confirmModalForm.get('note')?.errors?.['required']) {
                                    <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.NoteRequired}}</p>
                                    }
                                </div>
                                }
                            }
                            @if (enableTypeToConfirm() === true) {
                                <ms-input-label [isRequired]="enableTypeToConfirm()" [labelText]="'Type ' + typeToConfirmText() + ' to confirm'" class="mt-3" />
                                <input type="text" id="typeToConfirm" [required]="enableTypeToConfirm()" maxlength="255"
                                    formControlName="typeToConfirm" class="form-control"
                                    [class.is-invalid]="confirmModalForm.get('typeToConfirm')?.invalid && confirmModalForm.get('typeToConfirm')?.touched"
                                    [class.is-valid]="confirmModalForm.get('typeToConfirm')?.valid && confirmModalForm.get('typeToConfirm')?.touched && confirmModalForm.get('typeToConfirm')?.value !== ''">
                                @if(confirmModalForm.get('typeToConfirm')?.invalid && confirmModalForm.get('typeToConfirm')?.touched) {
                                <div class="error-messages">
                                    @if(confirmModalForm.get('typeToConfirm')?.errors?.['required']) {
                                    <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.TypeToConfirmRequired}}</p>
                                    }
                                    @if(confirmModalForm.get('typeToConfirm')?.errors?.['matchTypeToConfirm']) {
                                    <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.TypeToConfirmMismatch}}</p>
                                    }
                                </div>
                                }
                            }
                        </form>
                    </div>

            </div>

            <div class="modal-footer border-0 d-flex justify-content-center pb-4">
                <!-- Both close off while the answer is being acted on: the spinner alone leaves the
                     question answerable a second time, and leaves Cancel able to dismiss a dialog whose
                     work is still running. -->
                <button type="button" class="btn btn-ms-secondary w-25" (click)="onCancel()"
                    [disabled]="isLocked()"
                    [msTooltip]="cancelButtonTooltip()" [msTooltipDisabled]="!cancelButtonTooltip()">
                    {{ cancelButtonText() }}
                </button>
                <button type="button" class="btn" [class]="confirmButtonClassName()" (click)="onConfirm()"
                    [disabled]="isLocked()"
                    [msTooltip]="confirmButtonTooltip()" [msTooltipDisabled]="!confirmButtonTooltip()">
                    @if(isSubmitting()) {
                        <div class="spinner-border text-light spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    } @else {
                        {{ confirmButtonText() }}
                    }
                </button>
            </div>

        </div>
    </div>
</div>